// EmptyState.jsx — consistent "no data" panel for admin tabs.
//
// Renders a title and optional body; pass an `icon` slot (e.g. an inline SVG
// or icon component — no emoji) to show a glyph in the accent frame, and an
// `action` slot to include a call-to-action button.

import React from 'react';

export default function EmptyState({
  icon = null,
  title,
  description,
  action,
  className = '',
}) {
  const finalClass = className ? `retro-empty ${className}` : 'retro-empty';
  return (
    <div className={finalClass} role="status">
      {icon && (
        <div className="retro-empty-icon" aria-hidden="true">
          {icon}
        </div>
      )}
      {title && <div className="retro-empty-title">{title}</div>}
      {description && <div className="retro-empty-body">{description}</div>}
      {action && <div style={{ marginTop: 'var(--space-2)' }}>{action}</div>}
    </div>
  );
}
